/**
 * ============================================================================
 * KpiCard — single KPI tile rendered in the ReviewMinutes KPI grid.
 * Owner: Phase 7 — Management Review Module (Agent F).
 * ============================================================================
 */

import styles from './ReviewMinutes.module.css';

export interface KpiCardProps {
  label: string;
  value: number | string;
  isCritical?: boolean;
}

export function KpiCard({ label, value, isCritical }: KpiCardProps) {
  const cls = isCritical
    ? `${styles.kpiCard} ${styles.kpiCardCritical}`
    : styles.kpiCard;
  return (
    <div className={cls} role="figure" aria-label={`KPI ${label}: ${value}`}>
      <div className={styles.kpiCardLabel}>{label}</div>
      <div className={styles.kpiCardValue}>{value}</div>
    </div>
  );
}
